export const DEFAULT_EASE = [0.6, 0.01, -0.05, 0.9];
